(function () {

  'use strict';

  function pxWorkflowDestination(DESTINATIONS) {
    return {
      restrict: 'E',
      scope: {
        me: '=',
        tenant: '=',
        workflowForm: '=',
        workflowFormModel: '=',
        fileNameShorthands: '=',
        fileNameFormModel: '=',
        emailFormModel: '=',
        filePathFormModel_ONEDRIVE: '=filePathFormModelOnedrive',
        filePathFormModel_SHAREPOINT: '=filePathFormModelSharepoint'
      },
      templateUrl: 'app/components/settings/workflows/workflowProperties/destination/workflowDestination.template.html',
      link: function (scope, element, attrs) {

        scope.selectPlaceHolder = 'Select';

        scope.DESTINATIONS = DESTINATIONS;

        scope.storeMetadataValuesOptions = [
          { id: undefined, name: 'No' },
          { id: 'JSON', name: 'AsJson' }
        ];

        scope.setDestinationType = function (item) {
          scope.workflowFormModel.destination = item.id;
        };

        scope.$watch(() => {
          return scope.workflowFormModel.destination;
        }, (newValue, oldValue) => {
          scope.fileNameFormModel?.updateFileName();

          scope.DESTINATION = scope.DESTINATIONS.find(destination => destination.id === scope.workflowFormModel.destination);
          switch (scope.DESTINATION.id) {
            case 'SEND_TO_ONEDRIVE':
              scope.filePathFormModel_ONEDRIVE?.updateFilePathExample();
              break;
            case 'SEND_TO_SHAREPOINT':
              scope.filePathFormModel_SHAREPOINT?.updateFilePathExample();
              break;
          }
        });

      }
    };
  }

  pxWorkflowDestination.$inject = ['DESTINATIONS'];

  angular
    .module('printix-admin')
    .directive('pxWorkflowDestination', pxWorkflowDestination);

})();
